import { Button, Flex, Label, pxToRem, useStyles } from '@archipro-design/aria';
import * as S from './FindNearest.mobile.style';
import { MapMarkerHovered } from '@archipro-design/icons';

export const FindNearestMobile = ({
    numberOfLocations,
    calculateDistance,
    showChangeSettingText,
    setShowChangeSettingText,
}: {
    numberOfLocations?: number;
    calculateDistance: () => Promise<boolean>;
    showChangeSettingText: boolean;
    setShowChangeSettingText: (showChangeSettingText: boolean) => void;
}) => {
    const { css } = useStyles();

    return (
        <Flex
            className={css(S.FindNearestSection)}
            vAlign="center"
            space="between"
            gap="space-40"
        >
            <div className={css(S.LocationsText)}>
                {numberOfLocations ?? 0} LOCATIONS
            </div>
            <Flex>
                {!showChangeSettingText ? (
                    <Button
                        transparent={true}
                        onClick={async () => {
                            const hasDistance = await calculateDistance();
                            if (!hasDistance) {
                                setShowChangeSettingText(
                                    !showChangeSettingText,
                                );
                            }
                        }}
                        iconAfter={<MapMarkerHovered />}
                        size={18}
                        text
                        variables={{
                            iconPadding: 0,
                            buttonSize18IconXMargin: pxToRem(8),
                        }}
                    >
                        FIND NEAREST
                    </Button>
                ) : (
                    <Label
                        variant="01"
                        weight="regular"
                        className={css(S.FindNearestText)}
                    >
                        Please change your browser settings to allow location
                        services.
                    </Label>
                )}
            </Flex>
        </Flex>
    );
};
